import Link from 'next/link';
import Heading from '@/components/shared/Heading';
import { routes } from '@/utils/routes';

interface ISubjectBlockProps {
  title: string;
  categorySlug: string;
  subCategorySlug?: string;
  links?: {
    slug: string;
    question: string;
  }[];
  className?: string;
  actions?: React.ReactNode;
  heading?: 'h1' | 'h2';
}
export const SubjectBlock = ({
  title,
  categorySlug,
  links,
  actions,
  className,
  heading = 'h2'
}: ISubjectBlockProps) => (
  <div className={className}>
    <Heading className="pb-6 text-2xl font-bold text-blue-400" variant={heading}>
      {title}
    </Heading>
    <ul className="flex flex-col gap-2 pb-10">
      {links?.map((link) => (
        <li key={link.slug}>
          <Link
            href={routes.helpCenterAnswer(categorySlug, link.slug)}
            className="font-regular text-grey-700"
          >
            {link.question}
          </Link>
        </li>
      ))}
    </ul>
    {actions && <div className="flex items-center justify-start gap-4">{actions}</div>}
  </div>
);
